module.exports = __webpack_public_path__ + "static/velkomin-i-fordrykk-kall-ef8c45b31942c36e8f7aac3b633a1d78.png";